import React from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

/**
 * Small wrapper matching the native `<select>` API but rendering shadcn.
 *
 * Props:
 *  - value        current value (string, "" allowed)
 *  - onChange     (newValue) => void
 *  - options      array of {value, label}
 *  - placeholder  fallback text
 *  - testid       data-testid on the trigger
 *  - className    extra classes for the trigger
 */
export default function SelectMenu({
  value = "",
  onChange,
  options = [],
  placeholder,
  testid,
  className = "",
  disabled,
}) {
  // shadcn Select doesn't allow empty-string values on SelectItem, so map "" → "__all"
  const EMPTY = "__all";
  const outbound = value === "" ? EMPTY : value;
  const handle = (v) => onChange?.(v === EMPTY ? "" : v);
  return (
    <Select value={outbound} onValueChange={handle} disabled={disabled}>
      <SelectTrigger
        data-testid={testid}
        className={`h-9 bg-zinc-900 border-zinc-800 text-sm text-zinc-200 ${className}`}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-200">
        {options.map((o) => (
          <SelectItem
            key={o.value === "" ? EMPTY : o.value}
            value={o.value === "" ? EMPTY : o.value}
            className="text-sm focus:bg-zinc-800 focus:text-zinc-100"
          >
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
